import "../../../css/IconStyle.css";

const VehicleTypeIcon = () => {
  return (
    <svg
      fill="currentColor"
      viewBox="-10 -10 315.238 315.238"
      width="25"
      height="25"
      className="sidebar-icon vehicle-type-icon"
      style={{ transformOrigin: "center" }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <g>
          <g>
            <path
              d="M147.619,0C66.219,0,0,66.224,0,147.619s66.219,147.619,147.619,147.619s147.619-66.224,147.619-147.619S229.019,0,147.619,0z M147.619,285.714c-76.143,0-138.095-61.948-138.095-138.095S71.476,9.524,147.619,9.524s138.095,61.948,138.095,138.095S223.762,285.714,147.619,285.714z"
              fill="currentColor"
              stroke="currentColor"
              strokeWidth="10"
            />
            <path
              d="M255.7,129.952l0.019-0.019c-0.01-0.01-0.014-0.014-0.024-0.024c-8.495-51.995-53.714-91.814-108.076-91.814S48.038,77.914,39.548,129.91c-0.01,0.01-0.014,0.014-0.024,0.024l0.019,0.019c-0.938,5.752-1.448,11.652-1.448,17.667c0,60.39,49.129,109.524,109.524,109.524s109.524-49.133,109.524-109.524C257.143,141.605,256.633,135.705,255.7,129.952z M147.619,47.619c45.295,0,83.6,30.295,95.852,71.671c-26.952-20.957-62.348-33.576-95.852-33.576c-33.504,0-68.895,12.619-95.852,33.581C64.019,77.914,102.324,47.619,147.619,47.619z M53.752,181.771c6.643-5.852,24.314-19.867,41.486-19.867c17.357,0,28.571,13.086,28.571,33.333c0,19.348-9.495,36.629-14.69,44.652C83.481,229.152,63.329,207.995,53.752,181.771z M186.11,239.895c-5.2-8.005-14.681-25.243-14.681-44.657c0-20.248,11.214-33.333,28.571-33.333c17.124,0,34.829,14.019,41.481,19.876C231.905,208,211.752,229.157,186.11,239.895z M244.525,171.852c-9.086-7.448-26.533-19.471-44.524-19.471c-22.429,0-38.095,17.624-38.095,42.857c0,20.49,9.048,38.405,15.005,47.986c-9.267,2.843-19.1,4.395-29.29,4.395c-10.19,0-20.026-1.552-29.292-4.395c5.957-9.581,15.005-27.495,15.005-47.986c0-25.233-15.667-42.857-38.095-42.857c-17.99,0-35.438,12.024-44.524,19.471c-1.948-7.776-3.095-15.862-3.095-24.233c0-4.452,0.395-8.805,0.962-13.105c26.052-24.276,63.662-39.276,99.038-39.276c35.381,0,72.99,15,99.038,39.276c0.567,4.3,0.962,8.652,0.962,13.105C247.62,155.99,246.472,164.076,244.525,171.852z"
              fill="currentColor"
              stroke="currentColor"
              strokeWidth="10"
            />
            <path
              d="M147.619,109.523c-13.129,0-23.81,10.681-23.81,23.81c0,13.129,10.681,23.81,23.81,23.81c13.129,0,23.81-10.681,23.81-23.81C171.429,120.204,160.748,109.523,147.619,109.523z M147.619,147.619c-7.876,0-14.286-6.41-14.286-14.286s6.41-14.286,14.286-14.286s14.286,6.41,14.286,14.286C161.905,141.209,155.495,147.619,147.619,147.619z"
              fill="currentColor"
              stroke="currentColor"
              strokeWidth="10"
            />
            <rect x="104.762" y="128.571" width="9.524" height="9.524" />
            <rect x="180.952" y="128.571" width="9.524" height="9.524" />
            <rect x="133.333" y="266.667" width="9.524" height="9.524" />
            <rect x="152.381" y="266.667" width="9.524" height="9.524" />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default VehicleTypeIcon;
